export default [
  {
    path: '/talent',
    name: 'talent',
    component: () => import('@/views/pages/team/talent/List.vue'),
    meta: {
      resource: 'Talent',
      action: 'manage',
    },
  },
  {
    path: '/talent/add',
    name: 'add-talent',
    component: () => import('@/views/pages/team/talent/Add.vue'),
    meta: {
      resource: 'Talent',
      action: 'manage',
    },
  },
  {
    path: '/talent/edit',
    name: 'edit-talent',
    component: () => import('@/views/pages/team/talent/Edit.vue'),
    meta: {
      resource: 'Talent',
      action: 'manage',
    },
  },
  {
    path: '/presence',
    name: 'presence',
    component: () => import('@/views/pages/team/presence/View.vue'),
    meta: {
      resource: 'Presensi Talent',
      action: 'manage',
    },
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('@/views/pages/team/invoice/List.vue'),
    meta: {
      resource: 'Invoice',
      action: 'manage',
    },
  },
  {
    path: '/invoice/:id',
    name: 'detail-invoice',
    component: () => import('@/views/pages/team/invoice/Detail.vue'),
    meta: {
      resource: 'Invoice Detail',
      action: 'manage',
    },
  },
  {
    path: '/onboarding/komtim',
    name: 'komtim-partner-onboarding',
    component: () => import('@/views/pages/team/onboarding/Onboarding.vue'),
    meta: {
      resource: 'Komtim Partner Onboarding',
      action: 'manage',
      layout: 'full',
    },
  },
]
